<span class="merge-snackbar"
    style="height: 61px; font-size: 16; font-weight: 600; padding: 20px 15px; min-width: 157px;" matSnackBarLabel>
    {{length}} user(s) selected
</span>
<span matSnackBarActions>
    <button *ngIf="length != 0 && allow_export" (click)="exportUsers(); snackBarRef.dismissWithAction();"
          style="height: 40px;font-weight: 700;"
          color="accent" class="usa-button export">
        <span class="export-button-text"><fa-icon class="fa-solid export-icon" [icon]="faDownload"></fa-icon>
        &nbsp;Export to CSV</span></button>
    <button *ngIf="length != 0 && allow_delete && canDelete" (click)="deleteUsers(); snackBarRef.dismissWithAction();"
        style="height: 40px;font-weight: 700;"
        color="accent" class="usa-button delete">
        <i class="material-icons">delete</i>
        Delete</button>
    <button *ngIf="length != 0 && allow_remove" (click)="removeUsers(); snackBarRef.dismissWithAction();"
        style="height: 40px;font-weight: 700;"
        color="accent" class="usa-button remove">
        <i class="material-icons">person_off</i>
        Remove</button>
    <button *ngIf="gis" class="usa-button gis"
            style="height: 40px;font-weight: 700;"
            color="accent"
            (click)="editCerts(); snackBarRef.dismissWithAction();"
    >
        <span class="gis-button-text"><fa-icon class="fa-solid gis-icon" [icon]="faEdit" ></fa-icon>
        Edit Certifications</span>
    </button>
    <button mat-icon-button class="exit_button" style="min-width: 0px;" (click)="snackBarRef.dismiss(); clearList()">
        <mat-icon style="color: #ffffff;">close</mat-icon>
    </button>
</span>
